<template>
  <div class="questionBox">
    <ul>
      <li
        v-for="(item, index) in questionList"
        :key="index"
        :class="questionIndex == index ? 'active' : ''"
        @click="show(index)"
      >
        <div class="questionDetail">
          <p class="name">{{ item.name }}</p>
          <p class="describe">{{ item.describe }}</p>
        </div>
        <div :class="['questionDetailList',questionIndex == index ? 'showList' : '']">
          <ul>
            <li
              v-for="(item1, index1) in item.list"
              :key="index + index1"
              @click.stop="goDetail(item1)"
            >
              <p>{{ item1.title }}</p>
              <i></i>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "常见问题",
    };
  },
  name: "question",
  data() {
    return {
      questionIndex: -1,
      questionList: [
        {
          helptype: 2000,
          name: "账户问题",
          describe: "账号绑定、密码、个人信息等",
          list: [],
        },
        {
          helptype: 2001,
          name: "购买问题",
          describe: "购买课程、充值、兑换码等",
          list: [],
        },
        {
          helptype: 2002,
          name: "发票问题",
          describe: "课程、充值、实物等",
          list: [],
        },
        {
          helptype: 2003,
          name: "使用问题",
          describe: "纠错、异常、其他等",
          list: [],
        },
      ],
    };
  },
  components: {},
  mounted() {
     this.getQuestion();
  },
  methods: {
    show(index) {
      this.questionIndex = this.questionIndex == index ? -1 : index;
    },
    getQuestion() {
      var questionList = this.questionList;
      for (let i = 0; i < questionList.length; i++) {
        var obj = {
           helptype: questionList[i].helptype,
      };
        this.$post( "iart-api-cmn/api/cmn/platform/queryByPlatformHelps",obj).then((res) => {
        if (res.code == 1) {
          this.questionList[i].list = res.data;
        } else {
          this.util.toast({ msg: res.message });
        }
      });
      }
    },
    goDetail(item) {
      this.$store.commit('setQuestion', JSON.stringify(item));
      this.$router.push({
        path: "/common/mine/question/questionDetail",
        query: {},
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.questionBox {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 100%;
  background: #f4f4f7;
  padding: 16px 16px;
  overflow: auto;
  > ul {
    > li {
      background: #ffffff;
      margin-bottom: 16px;
      .questionDetail {
        padding: 20px 0;
        margin: 0 16px;
        padding-right: 20px;
        position: relative;
        .name {
          font-size: 16px;
          line-height: 22px;
          color: #35363c;
          font-weight: 500;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .describe {
          font-size: 12px;
          font-weight: 300;
          line-height: 21px;
          color: #35363c;
          margin-top: 8px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .questionDetailList {
        background: #ffffff;
        height: 0;
        overflow: hidden;
        transition: all linear 0.2s;
        li {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          margin: 0 16px;
          border-top: 1px solid #ededed;
          p {
            padding: 16px 0;
            flex: 1;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 14px;
            font-weight: 300;
            line-height: 20px;
            color: #35363c;
          }
          i {
            display: inline-block;
            width: 24px;
            height: 24px;
            background: url(../../../../assets/img/h5/triangle_d_b.png) no-repeat;
            transform: rotate(-90deg);
            background-size: 24px 24px;
          }
        }
      }
      .showList {
        height: auto;
        overflow: hidden;
        transition: all linear 0.2s;
      }
      .questionDetail::before {
        content: " ";
        display: inline-block;
        width: 24px;
        height: 24px;
        background: url(../../../../assets/img/h5/arrow_d_b.png) no-repeat;
        background-size: 24px 24px;
        position: absolute;
        right: 0;
        top: 50%;
        margin-top: -5.5px;
        transform: rotate(0);
        transition: all linear 0.2s;
      }
    }
    // > li:not(:last-child) .questionDetail {
    //   border-bottom: 1px solid #ededed;
    // }
    > li.active .questionDetail {
      border-bottom-color: transparent;
      padding-bottom: 12px;
    }
    > li.active .questionDetail::before {
      transform: rotate(-180deg);
      transition: all linear 0.2s;
    }
  }
}
</style>